import { ReactNode, ReactElement, createElement } from "react";

const sharedRichtextValues: {
    [key: string]: (
        chunks: ReactNode,
        key?: string,
        href?: string
    ) => ReactElement;
} = {
    p: (chunks: ReactNode, key?: string) => <p key={key}>{chunks}</p>,
    strong: (chunks: ReactNode, key?: string) => (
        <strong key={key}>{chunks}</strong>
    ),
    ul: (chunks: ReactNode, key?: string) => <ul key={key}>{chunks}</ul>,
    li: (chunks: ReactNode, key?: string) => <li key={key}>{chunks}</li>,
    a: (chunks: ReactNode, key?: string, href?: string) => (
        <a key={key} href={href}>
            {chunks}
        </a>
    ),
    br: (_chunks: ReactNode, key?: string) => <br key={key} />
};

const convertToReact = (node: ChildNode, key?: string): ReactNode => {
    if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent;
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node as HTMLElement;
        const tagName = element.tagName.toLowerCase();
        const children = Array.from(element.childNodes).map((child, index) =>
            convertToReact(child, `${key}-${index}`)
        );

        const renderFunction = sharedRichtextValues[tagName];
        if (renderFunction) {
            return renderFunction(
                children,
                key,
                element.getAttribute("href") || undefined
            );
        } else {
            return createElement(tagName, { key }, children);
        }
    }

    return null;
};

export const parseHtmlString = (htmlString: string | undefined): ReactNode => {
    if (!htmlString) {
        return null;
    }

    if (typeof document === "undefined") {
        return null;
    }

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    return convertToReact(tempDiv, "root");
};
